module.exports = __webpack_public_path__ + "static/media/Bell_beaker_mba_wales_text_01.d0a8da31.jpg";